import React, { useState } from 'react';
import { Box, Button, ButtonGroup, Typography, Paper, Grid } from '@mui/material';
import Loader from './Loader';

const LoaderDemo: React.FC = () => {
  const [variant, setVariant] = useState<'rotate' | 'pulse' | 'bounce' | 'shimmer' | 'walk'>('walk');
  const [showText, setShowText] = useState(true);

  const variants = [
    { name: 'walk', label: 'Walk' },
    { name: 'rotate', label: 'Rotate' },
    { name: 'pulse', label: 'Pulse' },
    { name: 'bounce', label: 'Bounce' },
    { name: 'shimmer', label: 'Shimmer' },
  ] as const;

  return (
    <Box sx={{ p: 4, maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h3" gutterBottom align="center" sx={{ mb: 4 }}>
        Sebear Animated Loader
      </Typography>
      
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <ButtonGroup variant="outlined" sx={{ mb: 2 }}>
          {variants.map((v) => (
            <Button
              key={v.name}
              onClick={() => setVariant(v.name)}
              variant={variant === v.name ? 'contained' : 'outlined'}
            >
              {v.label}
            </Button>
          ))}
        </ButtonGroup>
        
        <Button
          variant="outlined"
          onClick={() => setShowText(!showText)}
          sx={{ ml: 2 }}
        >
          {showText ? 'Hide Text' : 'Show Text'}
        </Button>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Walking Bear (Default)
            </Typography>
            <Loader 
              variant={variant} 
              text={showText ? 'Loading...' : undefined}
            />
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Large Size (120px)
            </Typography>
            <Loader 
              size={120}
              variant={variant} 
              text={showText ? 'Processing...' : undefined}
            />
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Small Size (60px)
            </Typography>
            <Loader 
              size={60}
              variant={variant} 
              text={showText ? 'Please wait...' : undefined}
            />
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Custom Color
            </Typography>
            <Loader 
              size={80}
              variant={variant} 
              color="#ff6b35"
              text={showText ? 'Connecting...' : undefined}
            />
          </Paper>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4, p: 3, bgcolor: 'grey.100', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Usage Examples:
        </Typography>
        <Box component="pre" sx={{ bgcolor: 'grey.200', p: 2, borderRadius: 1, overflow: 'auto' }}>
{`// Walking bear (new default)
<Loader />

// With custom variant
<Loader variant="walk" />

// With custom size and text
<Loader size={100} text="Loading data..." />

// With custom color
<Loader color="#ff6b35" variant="walk" />

// Without text
<Loader text={undefined} />`}
        </Box>
      </Box>
    </Box>
  );
};

export default LoaderDemo;